import { useCategory } from '../contexts/CategoryContext'
import { useCart } from '../contexts/CartContext'

export const useCurrentVendor = () => {
  const [categories] = useCategory()
  const [, { currentVendorId }] = useCart()
  return categories.find(vendor => vendor.id === currentVendorId) || null
}
